import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { flushSync } from "react-dom";

import Print, { type PrintHandle } from "@components/print/print";

import valueFormatter from "@modules/value_formatter";
import dayjs from "dayjs";

import "./print_label.scoped.scss";
import printLogo from "@user/assets/images/common/logo-print.svg";
import FitText from "@user/views/print/print_label_text";

export interface PrintLabelData {
  pn: string;
  trNo: string;
  sn: string;
  loc: string;
  expireDate?: string;
}

export interface PrintLabelHandle {
  print: (infos: any[]) => Promise<void>;
}

const PrintLabel = forwardRef<PrintLabelHandle>((_, ref) => {
  const printRef = useRef<PrintHandle>(null);
  const [dataList, setDataList] = useState<PrintLabelData[]>([]);

  useImperativeHandle(ref, () => ({
    print: async (infos: any[]) => {
      const labelDataList: PrintLabelData[] = infos.map((info) => ({
        pn: info.pn,
        trNo: info.trNo,
        sn: info.sn,
        loc: (info.wh === "N0" || info.wh === "M0P") ? info.wh + " 00000" : "",
        expireDate: info.expireDate,
      }));
      flushSync(() => setDataList(labelDataList));
      await printRef.current?.print();
      setDataList([]);
    }
  }));

  return (
    <Print ref={printRef}>
      {dataList.map((data, idx) => (
        <div className="print-label" key={idx}>
          <div>
            <p>P/N</p>
            <FitText maxFontSize={50} minFontSize={10}>{data.pn ?? ""}</FitText>
          </div>
          {!data.sn && data.trNo &&
          <div>
            <p>TR</p>
            <FitText maxFontSize={50} minFontSize={10}>{data.trNo ?? ""}</FitText>
          </div>
          }
          {data.sn &&
          <div>
            <p>S/N</p>
            <FitText maxFontSize={50} minFontSize={10}>{data.sn ?? ""}</FitText>
          </div>
          }
          <div>
            <p>LOC</p>
            <FitText maxFontSize={50} minFontSize={10}>{data.loc ?? ""}</FitText>
          </div>
          <div>
            <p className="duedate">DUE DATE<br /><em>(YYYY-MM-DD)</em></p>
            <FitText maxFontSize={40} minFontSize={10}>{data.expireDate ? dayjs(data.expireDate).format("YYYY-MM-DD") : "N/A"}</FitText>
          </div>
          <div className="logo"><img src={printLogo} alt="KOREAN AIR" /></div>
          <p>
            <span>130mm X 90mm / STICKER<br />Revision date : R4 / 2025.11.25</span>
            <span>KE-MA-842<br />Issue date : 2002.04.15</span>
          </p>
        </div>
      ))}
    </Print>
  );
});

export default React.memo(PrintLabel);
